import { h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';
import { feedbackElements } from '../../../conversational-search-logic/utils/utils';
import { ChatIcons, ChatIconsColors } from '../../../conversational-search-types/conversational-search-types.type';
import { ConversationalSearchActions } from '../../../conversational-search-partials/actions/actions';

const initialView = (
  labelProvider: labelProviderInterface,
  query: string,
  callback: (variant: string) => void,
) => {
    const feedbackElementsToRender = feedbackElements(labelProvider);

    return (
      <div class="conversational-search-banner-dynamic-feedback-initial">
        <span class="conversational-search-banner-dynamic-feedback-initial__text">
          {labelProvider(
            'conversational.search.banner.dynamic.result.feedback',
            'Was this helpful?',
          )}
        </span>
        {feedbackElementsToRender.map((item) => (
          <span onClick={() => callback(item.variant)}>
            <ConversationalSearchActions
              iconName={item.icon}
              query={query}
              text={item.text}
              variant={item.variant}
              bannerVariant={true}
            />
          </span>
        ))}
      </div>
    );
};

const interactedView = (
  color: ChatIconsColors,
  icon: ChatIcons,
  text: string,
  labelProvider: labelProviderInterface,
  medalliaCallback: () => void,
) => (
  <div class="conversational-search-banner-dynamic-feedback-interacted">
    <se-icon color={color}>{icon}</se-icon>
    <span>{text}</span>
    <qds-button
      importance="subdued"
      onClick={() => medalliaCallback()}
      text={labelProvider('conversational.search.feedback.share', 'Feedback')}
      size="small"
    />
  </div>
);

const interactedViewConfig = (
  activeVariant: string,
  labelProvider: labelProviderInterface,
) => {
    switch (activeVariant) {
    case 'Like':
      return {
        color: ChatIconsColors.SUCCESS_ICON_COLOR,
        icon: ChatIcons.SUCCESS_ICON,
        text: labelProvider(
          'conversational.search.action.like',
          'Glad you liked the answer!',
        ),
      };
    case 'Dislike':
      return {
        color: ChatIconsColors.WARNING_ICON_COLOR,
        icon: ChatIcons.WARNING_ICON,
        text: labelProvider(
          'conversational.search.action.dislike',
          'Why did you choose this rating?',
        ),
      };
    default:
      return null;
    }
};

export const renderFeedback = (
  labelProvider: labelProviderInterface,
  query: string,
  activeVariant: string | undefined,
  callback: (variant: string) => void,
  medalliaCallback: () => void,
) => {
    if (!activeVariant) return initialView(labelProvider, query, callback);

    const config = interactedViewConfig(activeVariant, labelProvider);
    return config ? interactedView(config.color, config.icon, config.text, labelProvider, medalliaCallback) : null;
};
